var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('structure-list',{ref:"share_modal",attrs:{"id":"share_modal","bauhof-structure":_vm.possibleShares,"multi-select":true,"is-share":true},on:{"on-selected":_vm.onShare,"on-forward-open":_vm.onForwardOpen,"hidden":_vm.hidden}})}
var staticRenderFns = []

export { render, staticRenderFns }